"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResetPasswordInstructionsScreen = void 0;
const react_1 = __importDefault(require("react"));
const react_div_100vh_1 = __importDefault(require("react-div-100vh"));
const components_1 = require("@/components");
const constants_1 = __importStar(require("@/constants"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const ResetPasswordInstructionsScreen = () => (react_1.default.createElement(react_div_100vh_1.default, { className: styles_scss_1.default.container },
    react_1.default.createElement(components_1.Meta, { title: constants_1.default.instructions.helmetTitle }),
    react_1.default.createElement("div", { className: styles_scss_1.default.leftContainer },
        react_1.default.createElement("img", { className: styles_scss_1.default.backgroundImage, src: constants_1.Images.loginBackground, alt: constants_1.Images.loginBackground }),
        react_1.default.createElement("div", { className: styles_scss_1.default.leftContainerContent },
            react_1.default.createElement("div", { className: styles_scss_1.default.formContainer },
                react_1.default.createElement("img", { className: styles_scss_1.default.mailSentImg, src: constants_1.Images.mailSent, alt: "mail-sent" }),
                react_1.default.createElement("h3", { className: styles_scss_1.default.title }, constants_1.default.instructions.title),
                react_1.default.createElement("div", { className: styles_scss_1.default.description }, constants_1.default.instructions.description),
                react_1.default.createElement(components_1.Link, { to: constants_1.Routes.Login },
                    react_1.default.createElement(components_1.Button, { ariaLabel: "Open Email App", className: styles_scss_1.default.emailButton }, constants_1.default.instructions.goBackToSignIn))))),
    react_1.default.createElement("div", { className: styles_scss_1.default.rightContainer },
        react_1.default.createElement("img", { src: constants_1.Images.loginBackground, alt: constants_1.Images.loginBackground }))));
exports.ResetPasswordInstructionsScreen = ResetPasswordInstructionsScreen;
exports.default = exports.ResetPasswordInstructionsScreen;
